export interface MemeberProfileCardProps {
  cardTitle?: string;
  children: React.ReactNode;
  dataTestId?: string;
}

export const MemberProfileCard = ({
  cardTitle = '',
  children,
  dataTestId = cardTitle
}: MemeberProfileCardProps) => {
  return (
    <div
      className="bg-soFresh-110 min-h-96 overflow-auto rounded-lg p-6"
      data-testid={dataTestId}
    >
      {cardTitle && <h2 className="text-soClean-110 pb-4">{cardTitle}</h2>}
      {children}
    </div>
  );
};
